import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import $ from 'jquery';

import 'jquery/dist/jquery.min.js';
import 'datatables.net-dt/js/dataTables.dataTables';
import 'datatables.net-buttons/js/dataTables.buttons.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.flash.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-dt/css/jquery.dataTables.min.css';

const PartialStudentTable = () => {
  const [Engg, setEngg] = useState([]);
  const [Pcm, setPcm] = useState([]);
  const [Pcb, setPcb] = useState([]);
  const [Other, setOther] = useState([]);
  const [Mba, setMba] = useState([]);

  useEffect(() => {
    axios.get(`/all-partial-applications`).then((res) => {
      const { Engg, Pcm, Pcb, Other, Mba } = res.data.data[0];
      setEngg(Engg);
      setPcm(Pcm);
      setPcb(Pcb);
      setOther(Other);
      setMba(Mba);

      setTimeout(() => {
        $('#example').DataTable({
          pagingType: 'full_numbers',
          pageLength: 25,
          processing: true,
          dom: 'Bfrtip',
          buttons: ['copyHtml5', 'excelHtml5', 'csvHtml5', 'print', 'pdf'],
        });
      }, 1000);
    });
  }, []);

  const getSerialNumber = (offset, index) => offset + index + 1;

  return (
    <div style={{ width: '100%' }}>
      <div className="flex flex-col md:flex-row" style={{ width: '100%' }}>
        <section style={{ width: '100%' }}>
          <div
            id="main"
            className="main-content flex-1 bg-gray-100 mt-12 md:mt-2 pb-24 md:pb-5"
            style={{ width: '100%' }}
          >
            <div className="flex flex-wrap bg-white" style={{ width: '100%' }}>
              <div className="flex flex-col bg-white" style={{ width: '100%' }}>
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="overflow-x-auto">
                      <div className="MainDiv">
                        <div className="container p-5">
                          <table id="example" className="table table-hover table-bordered">
                            <thead>
                              <tr>
                                <th>Sl.No</th>
                                <th>Full Name</th>
                                <th>Mobile No</th>
                                <th>Email ID</th>
                                <th>Gender</th>
                                <th>Country</th>
                                <th>Program</th>
                                <th>Reg. Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Engg.map((result, i) => (
                                <tr key={`engg-${i}`}>
                                  <td>{getSerialNumber(0, i)}</td>
                                  <td>{result.name}</td>
                                  <td>{result.mobileNo}</td>
                                  <td>{result.email}</td>
                                  <td>{result.gender}</td>
                                  <td>India</td>
                                  <td>Engg</td>
                                  <td>{result.createdAt}</td>
                                </tr>
                              ))}
                              {Pcm.map((result, i) => (
                                <tr key={`pcm-${i}`}>
                                  <td>{getSerialNumber(Engg.length, i)}</td>
                                  <td>{result.name}</td>
                                  <td>{result.mobileNo}</td>
                                  <td>{result.email}</td>
                                  <td>{result.gender}</td>
                                  <td>India</td>
                                  <td>PCM</td>
                                  <td>{result.createdAt}</td>
                                </tr>
                              ))}
                              {Pcb.map((result, i) => (
                                <tr key={`pcb-${i}`}>
                                  <td>{getSerialNumber(Engg.length + Pcm.length, i)}</td>
                                  <td>{result.name}</td>
                                  <td>{result.mobileNo}</td>
                                  <td>{result.email}</td>
                                  <td>{result.gender}</td>
                                  <td>India</td>
                                  <td>PCB</td>
                                  <td>{result.createdAt}</td>
                                </tr>
                              ))}
                              {Other.map((result, i) => (
                                <tr key={`other-${i}`}>
                                  <td>{getSerialNumber(Engg.length + Pcm.length + Pcb.length, i)}</td>
                                  <td>{result.name}</td>
                                  <td>{result.mobileNo}</td>
                                  <td>{result.email}</td>
                                  <td>{result.gender}</td>
                                  <td>India</td>
                                  <td>Other UG</td>
                                  <td>{result.createdAt}</td>
                                </tr>
                              ))}
                              {Mba.map((result, i) => (
                                <tr key={`mba-${i}`}>
                                  <td>{getSerialNumber(Engg.length + Pcm.length + Pcb.length + Other.length, i)}</td>
                                  <td>{result.name}</td>
                                  <td>{result.mobileNo}</td>
                                  <td>{result.email}</td>
                                  <td>{result.gender}</td>
                                  <td>India</td>
                                  <td>MBA</td>
                                  <td>{result.createdAt}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PartialStudentTable;
